
const isTokenExpired = (token) => {
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload.exp * 1000 < Date.now();
  } catch {
    return true;
  }
};



/**
 * Replaces placeholder tokens like [BUSINESS_NAME] in a template string.
 *
 * Supported tokens (extend as needed):
 * [BUSINESS_NAME]
 * [BUSINESS_EMAIL]
 * [MINOR_FULL_NAME]
 * [MINOR_FIRST_NAME]
 * [PREVIOUS_SIGNED_DATE]
 *
 */
function replacePlaceholders(
  template,
  values = {},
  highlight = false,
  bold = false
) {
  if (!template || typeof template !== "string") return template;

  return template.replace(/\[([A-Z0-9_]+)\]/g, (match, key) => {
    if (Object.prototype.hasOwnProperty.call(values, key)) {
      let safeVal = escapeHtml(values[key] ?? "");

      if (bold) {
        safeVal = `<strong>${safeVal}</strong>`;
      }

      if (highlight) {
        safeVal = `<span class="ph-replaced">${safeVal}</span>`;
      }

      return safeVal;
    }

    return match;
  });
}
/* Example usage:
const text = `
This waiver is signed by [MINOR_FIRST_NAME] on behalf of [BUSINESS_NAME].
Contact: [BUSINESS_EMAIL]
Previous signed date: [PREVIOUS_SIGNED_DATE]
`;

const finalText = replacePlaceholders(text, {
  BUSINESS_NAME: "ABC Salon",
  BUSINESS_EMAIL: "contact@abc.com",
  MINOR_FIRST_NAME: "Riya",
  PREVIOUS_SIGNED_DATE: "12 Mar 2026",
});

*/

function fixProseSpacing(html) {
  return html
    // <p></p> → spacer paragraph
    .replace(/<p>\s*<\/p>/g, '<p class="my-4">&nbsp;</p>')
    // <p><br></p> → spacer paragraph
    .replace(/<p><br\s*\/?><\/p>/g, '<p class="my-4">&nbsp;</p>');
}

function escapeHtml(str) {
  return String(str)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}

/* It converts:
&amp;  →  &
&quot; →  "*/
function normalizeHtmlEntities(html) {
  const textarea = document.createElement("textarea");
  textarea.innerHTML = html;
  return textarea.value;
}

module.exports = {
  replacePlaceholders,
  fixProseSpacing,
  normalizeHtmlEntities,
  isTokenExpired,
};